import React, { useState } from 'react';
import { Row, Col, Label, Input, Button, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';
import MemberMembershipService from '../../../../../../services/member_membership_service';
import ConfirmDialog from '../../../../../../components/Common/ConfirmDialog';
import { formatCurrency } from '../../../../../../utils/format';
import { toISODate, formatDate } from '../../../../../../utils/date';

const ActionSuspend = ({ membership, idTenant, user, onRefresh }) => {
    const [suspendEndDate, setSuspendEndDate] = useState("");
    const [isScheduledSuspend, setIsScheduledSuspend] = useState(false);
    const [suspendStartDate, setSuspendStartDate] = useState("");
    const [reason, setReason] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSuspend = async () => {
        if (!suspendEndDate) return toast.warning("Informe a data de término da suspensão.");
        if (isScheduledSuspend && !suspendStartDate) return toast.warning("Informe a data de início da suspensão agendada.");

        const startDate = isScheduledSuspend ? suspendStartDate : toISODate(new Date());
        const sTime = new Date(startDate + "T00:00:00").getTime();
        const eTime = new Date(suspendEndDate + "T00:00:00").getTime();

        if (eTime <= sTime) return toast.warning("Data final deve ser posterior à data inicial.");

        const n = Math.round((eTime - sTime) / (1000 * 60 * 60 * 24));

        const ok = await ConfirmDialog({
            title: isScheduledSuspend ? "Agendar Suspensão?" : "Suspender plano?",
            text: isScheduledSuspend
                ? `O plano ficará suspenso do dia ${formatDate(startDate)} até ${formatDate(suspendEndDate)} (${n} dias).`
                : `O plano será suspenso a partir de hoje até ${formatDate(suspendEndDate)} (${n} dias).`,
            confirmButtonText: "Sim, confirmar",
        });
        if (!ok) return;

        setLoading(true);
        try {
            await MemberMembershipService.suspend(membership.id, idTenant, user, membership, {
                days: n,
                reason: reason || "Suspensão pelo gestor",
                startDate: startDate
            });
            toast.success(isScheduledSuspend ? "Suspensão agendada." : "Plano suspenso.");
            setSuspendEndDate("");
            setSuspendStartDate("");
            setIsScheduledSuspend(false);
            setReason("");
            onRefresh?.();
        } catch { toast.error("Erro ao suspender."); }
        finally { setLoading(false); }
    };

    return (
        <div className="p-4 border rounded-0 mt-3 bg-white">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <div className="d-flex align-items-center">
                    <i className="mdi mdi-pause-circle-outline fs-4 me-2 text-muted"></i>
                    <h6 className="fw-bold mb-0 text-dark text-uppercase" style={{ letterSpacing: "0.5px" }}>
                        Suspender Plano
                    </h6>
                </div>
                <div className="form-check form-switch font-size-12">
                    <input className="form-check-input" type="checkbox" role="switch" id="switchSchedSuspend"
                        checked={isScheduledSuspend} onChange={(e) => setIsScheduledSuspend(e.target.checked)} />
                    <label className="form-check-label text-muted ms-1" htmlFor="switchSchedSuspend">Agendar futuro?</label>
                </div>
            </div>

            <p className="text-muted font-size-13 mb-4">
                O trancamento (suspensão) paralisa a contagem do tempo do contrato. O tempo paralisado será adicionado ao final da vigência do aluno quando o período de suspensão acabar.
            </p>

            {membership.allowsSuspension && (
                <div className="d-flex align-items-center bg-light border p-2 rounded-0 mb-4">
                    <i className="mdi mdi-snowflake fs-5 text-muted mx-2"></i>
                    <div className="flex-grow-1 font-size-12 text-muted">
                        Dias disponíveis no contrato: <strong className="text-dark">{membership.disponibleSuspensionDays || 0}</strong> de {membership.maxSuspensionDays || 0}
                    </div>
                    {membership.suspensionFee > 0 && (
                        <div className="font-size-12 ms-3 pe-2 text-muted">
                            Taxa de bloqueio: <strong className="text-dark">{formatCurrency(membership.suspensionFee)}</strong>
                        </div>
                    )}
                </div>
            )}

            <Row className="g-3 align-items-start">
                <Col md={3}>
                    <Label className="font-size-12 fw-medium text-dark mb-1">Data Início</Label>
                    <Input
                        type="date"
                        bsSize="sm"
                        value={isScheduledSuspend ? suspendStartDate : toISODate(new Date())}
                        onChange={e => setSuspendStartDate(e.target.value)}
                        disabled={!isScheduledSuspend}
                        className="py-2 bg-light border-0"
                    />
                </Col>
                <Col md={3}>
                    <Label className="font-size-12 fw-medium text-dark mb-1">Data Fim</Label>
                    <Input
                        type="date"
                        bsSize="sm"
                        value={suspendEndDate}
                        onChange={e => setSuspendEndDate(e.target.value)}
                        className="py-2 bg-light border-0"
                    />
                </Col>
                <Col md={6}>
                    <Label className="font-size-12 fw-medium text-dark mb-1">Motivo (Opcional)</Label>
                    <Input
                        type="text"
                        bsSize="sm"
                        placeholder="Viagem, saúde..."
                        value={reason}
                        onChange={e => setReason(e.target.value)}
                        className="py-2 bg-light border-0"
                    />
                </Col>
            </Row>

            <div className="d-flex justify-content-end mt-4">
                <Button
                    color="dark"
                    className="px-4 fw-medium font-size-13 d-flex align-items-center rounded-0"
                    style={{ height: "36px" }}
                    onClick={handleSuspend}
                    disabled={loading}
                >
                    {loading ? <Spinner size="sm" className="me-2" /> : null}
                    Confirmar
                </Button>
            </div>
        </div>
    );
};

export default ActionSuspend;
